/** The domestic league table: position, record, goals and points. No badges — this site carries no images. */
export const LeagueTable = ({ table, prefix = "kpl-table" }) =>
  table?.rows?.length ? (
    <div className="overflow-x-auto border border-zinc-800" data-testid={`${prefix}-wrap`}>
      <table className="w-full min-w-[620px] border-collapse text-left">
        <thead>
          <tr className="border-b border-zinc-800 bg-[#0b0b0b]">
            {["#", "Club", "P", "W", "D", "L", "GF", "GA", "GD", "Pts"].map((h) => (
              <th
                key={h}
                className="px-3 py-3 text-[0.58rem] font-bold uppercase tracking-[0.16em] text-zinc-300 first:pl-4"
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {table.rows.map((r) => (
            <tr key={r.team} className="border-b border-zinc-900" data-testid={`${prefix}-row-${r.position}`}>
              <td className="mono px-3 py-2.5 pl-4 text-xs text-zinc-500">{r.position}</td>
              <td className="px-3 py-2.5 text-sm text-white">{r.team}</td>
              <td className="mono px-3 py-2.5 text-xs text-zinc-400">{r.played}</td>
              <td className="mono px-3 py-2.5 text-xs text-zinc-400">{r.won}</td>
              <td className="mono px-3 py-2.5 text-xs text-zinc-400">{r.drawn}</td>
              <td className="mono px-3 py-2.5 text-xs text-zinc-400">{r.lost}</td>
              <td className="mono px-3 py-2.5 text-xs text-zinc-500">{r.goals_for}</td>
              <td className="mono px-3 py-2.5 text-xs text-zinc-500">{r.goals_against}</td>
              <td className="mono px-3 py-2.5 text-xs text-zinc-500">
                {r.goal_difference > 0 ? "+" : ""}
                {r.goal_difference}
              </td>
              <td className="mono px-3 py-2.5 text-sm font-bold text-ochre">{r.points}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  ) : (
    <p className="border border-zinc-800 bg-[#0b0b0b] p-6 text-sm text-zinc-500" data-testid={`${prefix}-empty`}>
      The table has not been published yet.
    </p>
  );
